var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',{staticClass:"text-center headline font-weight-medium",attrs:{"cols":"12"}},[_c('div',{staticClass:"text-h3"},[_vm._v("iShareTo")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }